export default __webpack_public_path__ + "static/media/ISSO CLASS-6 EXAM PATTERN 2025.bb8f8791.pdf";